import React from 'react';

function My404Component(props) {
    return (
        <h2 style={{color:"white"}}> 
            Please enter a class code 
            <br></br>
            ritassignmentstracker.tk/classcode
        </h2>
    );
}

export default My404Component;